import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { clsx } from "clsx";
import Svg from "react-inlinesvg";
import { type IconDefinition } from "@fortawesome/fontawesome-svg-core";

import {
  getProductTagInformation,
  type ProductTagType
} from "./product-tags-util";

type ProductTagProps = {
  label?: string;
  backgroundColor?: string;
  faIcon?: IconDefinition;
  iconImage?: string;
};

export const ProductTag = ({
  label,
  backgroundColor,
  faIcon,
  iconImage
}: ProductTagProps) => {
  return (
    <div
      className={clsx(
        "flex h-7 flex-row items-center justify-center gap-1 rounded-md bg-kiosk-background-reversed px-2 text-sm text-white"
      )}
      // Can't set colors on runtime, therefore we need to use inline styles
      style={{
        backgroundColor
      }}
    >
      {faIcon ? (
        <FontAwesomeIcon
          icon={faIcon}
          className="size-4 text-inherit"
          data-testid="tags-fa-icon"
        />
      ) : null}
      {iconImage ? (
        <Svg
          src={iconImage}
          className="size-5 text-inherit"
          data-testid="tags-svg-icon"
        />
      ) : null}
      {label ? <span className="text-inherit font-bold">{label}</span> : null}
    </div>
  );
};

type ProductTagsWrapperProps = {
  tags: string[];
  languageCode: keyof ProductTagType["names"];
  showLabel?: boolean;
};

export const ProductTagsWrapper = ({
  tags: tagNames,
  languageCode,
  showLabel = true
}: ProductTagsWrapperProps) => {
  return (
    <div className="flex flex-wrap gap-1">
      {tagNames.map((tagName) => {
        const tagInformation = getProductTagInformation({
          name: tagName,
          languageCode
        });

        if (!tagInformation) {
          return null;
        }

        return (
          <ProductTag
            key={tagInformation.key}
            label={showLabel ? tagInformation.label : undefined}
            backgroundColor={tagInformation.backgroundColor}
            faIcon={tagInformation.faIcon}
            iconImage={tagInformation.iconImage}
          />
        );
      })}
    </div>
  );
};
